import { render, staticRenderFns } from "./ActividadesRecientes.vue?vue&type=template&id=06354d74&"
import script from "./ActividadesRecientes.vue?vue&type=script&lang=js&"
export * from "./ActividadesRecientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports